<template>
  <NavBar />
  <main class="container training-page" :aria-busy="isLoading">
    <section class="package-hero" aria-labelledby="package-title">
      <div class="package-copy">
        <span class="section-eyebrow">EĞİTİM PAKETİNİZ</span>
        <h1 id="package-title">{{ packageName || 'Paket Bilgileri' }}</h1>
        <p>Eğitim yolculuğunuzla ilgili tüm haklarınız bir arada.</p>
        <span class="package-badge"><i class="bi bi-book" aria-hidden="true"></i> Öğrenmeye devam edin</span>
      </div>
      <img class="package-image" src="@/assets/images/education/dashboard/package-overview.svg" alt="" width="320" height="240" decoding="async" />
    </section>

    <section class="rights-section" aria-labelledby="rights-title">
      <div class="section-heading">
        <h2 id="rights-title">Kalan Haklarınız</h2>
        <p>Eğitim planınızı kalan haklarınıza göre oluşturun.</p>
      </div>
      <p v-if="loadError" class="load-message" role="alert">Paket bilgileriniz yüklenemedi. Lütfen sayfayı yenileyerek tekrar deneyin.</p>
      <div class="rights-grid">
        <article v-for="right in rights" :key="right.key" class="right-card">
          <div class="right-heading">
            <h3>{{ right.title }}</h3>
            <span class="right-icon"><img :src="right.image" alt="" width="120" height="120" loading="lazy" decoding="async" /></span>
          </div>
          <div class="right-value" aria-live="polite">
            <span>{{ isLoading ? '…' : right.count ?? '—' }}</span>
            <span class="right-unit">{{ right.unit }}</span>
          </div>
          <!-- Kalan hak oranı ve ilerleme çubuğu daha sonra kullanılmak üzere gizlendi.
          <div class="right-progress-label">
            <span>Kalan hak oranı</span>
            <span>{{ isLoading || loadError ? '—' : '%' + right.rate }}</span>
          </div>
          <progress
            class="right-track"
            :value="right.rate"
            max="100"
            :aria-label="right.title + ' kalan hak oranı'"
          >{{ right.rate }}%</progress>
          -->
          <div class="right-divider" aria-hidden="true"></div>
          <p>{{ right.description }}</p>
        </article>
      </div>
    </section>

    <div class="details-grid">
      <section class="benefits-card" aria-labelledby="benefits-title">
        <span class="section-eyebrow">PAKETİNİZE DAHİL</span>
        <h2 id="benefits-title">Öğrenmenin avantajları</h2>
        <ul class="benefits-list">
          <li><i class="bi bi-check-circle-fill" aria-hidden="true"></i><span>Sınırsız öğrenci ekranı kullanımı</span></li>
          <li><i class="bi bi-check-circle-fill" aria-hidden="true"></i><span>Öğrenci ekranlarına <strong>7/24 erişim</strong></span></li>
          <li><i class="bi bi-check-circle-fill" aria-hidden="true"></i><span>Ücretsiz İngilizce eğitim materyalleri</span></li>
        </ul>
      </section>
      <section class="freeze-card" aria-labelledby="freeze-title">
        <div class="freeze-heading"><i class="bi bi-info-circle" aria-hidden="true"></i><h2 id="freeze-title">Ders dondurma koşulları</h2></div>
        <p>Eğitiminize ara vermeniz gerektiğinde:</p>
        <dl class="freeze-options">
          <div><dt>6 aylık paket</dt><dd>En fazla <strong>2 ay</strong></dd></div>
          <div><dt>12 aylık paket</dt><dd>En fazla <strong>4 ay</strong></dd></div>
        </dl>
        <p class="freeze-note">Ders dondurma hakkı yalnızca <strong>bir kez</strong> kullanılabilir; parça parça kullanılamaz.</p>
      </section>
    </div>
  </main>
  <FooterInPage />
</template>

<script>
import { mapActions } from 'vuex';
import { LoadingToast, UpdateToast, ToastType } from '@/common/notification.js';
import NavBar from '@/components/Shared/NavBar.vue';
import FooterInPage from '@/components/Shared/FooterInPage.vue';
import lessonImage from '@/assets/images/education/dashboard/lesson-book.svg';
import postponeImage from '@/assets/images/education/dashboard/lesson-postpone.svg';
import freezeImage from '@/assets/images/education/dashboard/lesson-pause.svg';

export default {
  name: 'TrainingFile',
  components: { NavBar, FooterInPage },
  data() {
    return {
      packageName: '',
      isLoading: true,
      loadError: false,
      rights: [
        { key: 'lesson', title: 'Ders Adedi', image: lessonImage, unit: 'ders', description: 'Öğrenmeye ayıracağınız zaman', count: null, rate: 0 },
        { key: 'postpone', title: 'Ders Erteleme', image: postponeImage, unit: 'adet', description: 'Planınız değiştiğinde yanınızda', count: null, rate: 0 },
        { key: 'freeze', title: 'Ders Dondurma', image: freezeImage, unit: 'adet', description: 'İhtiyaç duyduğunuzda bir mola', count: null, rate: 0 },
      ],
    };
  },
  methods: {
    ...mapActions(['GetTrainingPackageInfo']),
    async GetTrainingFile() {
      const toastId = LoadingToast();
      try {
        const res = await this.GetTrainingPackageInfo();
        this.packageName = res.packageName;
        this.rights.forEach((right) => {
          right.count = res[`${right.key}Count`] ?? null;
          const rate = Number(res[`${right.key}Rate`]);
          right.rate = Number.isFinite(rate) ? Math.min(100, Math.max(0, rate)) : 0;
        });
        UpdateToast(toastId, res.description, ToastType().SUCCESS, 100);
      } catch (err) {
        this.loadError = true;
        UpdateToast(toastId, err.message, ToastType().ERROR);
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.GetTrainingFile();
  },
};
</script>

<style scoped>
.training-page {
  --training-green: var(--brand-primary);
  max-width: 1100px;
  padding-top: 36px;
  padding-bottom: 48px;
  color: #343434;
}
.package-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  padding: 36px 40px;
  background: #fff;
  border: 1px solid #ededed;
  border-radius: 24px;
  box-shadow: 0 8px 32px rgb(0 0 0 / 3%);
}
.package-copy { min-width: 0; }
.section-eyebrow { display: block; color: #626262; font-size: 11px; font-weight: 700; letter-spacing: 1.6px; }
h1 { margin: 12px 0; font-size: clamp(25px, 3vw, 36px); font-weight: 700; line-height: 1.25; overflow-wrap: anywhere; }
.package-copy > p, .section-heading p { color: #6b6b6b; font-size: 14px; line-height: 1.7; margin-bottom: 0; }
.package-badge { display: inline-flex; align-items: center; gap: 8px; margin-top: 22px; padding: 8px 12px; border-radius: 8px; background: rgb(85 185 72 / 9%); font-size: 12px; }
.package-badge i { color: var(--training-green); }
.package-image { width: 220px; max-width: 32%; height: 160px; object-fit: contain; }
.rights-section { margin-top: 32px; }
h2 { font-size: 19px; font-weight: 700; line-height: 1.4; margin: 0; }
.section-heading { margin-bottom: 18px; }
.section-heading p { margin-top: 5px; }
.rights-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 18px; }
.right-card { padding: 24px; background: #fff; border: 1px solid #ededed; border-radius: 18px; box-shadow: 0 4px 18px rgb(0 0 0 / 2%); }
.right-heading { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
h3 { font-size: 15px; font-weight: 600; margin: 0; }
.right-icon { display: grid; place-items: center; width: 38px; height: 38px; flex-shrink: 0; border-radius: 12px; background: rgb(85 185 72 / 9%); color: var(--training-green); font-size: 19px; }
.right-icon img { display: block; width: 100%; height: 100%; object-fit: contain; }
.right-value { display: flex; align-items: baseline; gap: 9px; margin: 14px 0 18px; overflow-wrap: anywhere; }
.right-value > span:first-child { font-size: 42px; font-weight: 700; line-height: 1.2; }
.right-unit { font-size: 13px; color: #6b6b6b; }
.right-divider { width: 100%; height: 1px; background: #ededed; }
.right-progress-label { display: flex; justify-content: space-between; gap: 8px; margin-bottom: 8px; font-size: 12px; color: #6b6b6b; }
.right-track { display: block; appearance: none; -webkit-appearance: none; width: 100%; height: 8px; overflow: hidden; border: 0; background: #efefef; border-radius: 10px; accent-color: var(--brand-primary); }
.right-track::-webkit-progress-bar { background: #efefef; border-radius: 10px; }
.right-track::-webkit-progress-value { background: var(--brand-primary); border-radius: 10px; }
.right-track::-moz-progress-bar { background: var(--brand-primary); border-radius: 10px; }
.right-card > p { margin: 12px 0 0; font-size: 12px; color: #6b6b6b; line-height: 1.6; }
.details-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-top: 24px; }
.benefits-card, .freeze-card { padding: 28px; border-radius: 18px; }
.benefits-card { background: #fff; border: 1px solid #ededed; }
.benefits-card h2 { margin-top: 9px; }
.benefits-list { display: grid; gap: 18px; padding: 0; margin: 24px 0 0; list-style: none; }
.benefits-list li { display: flex; align-items: baseline; gap: 12px; font-size: 14px; line-height: 1.6; }
.benefits-list i { color: var(--training-green); flex-shrink: 0; }
.freeze-card { background: #f5f5f5; border: 1px solid #ededed; }
.freeze-heading { display: flex; align-items: baseline; gap: 10px; }
.freeze-heading > i { color: #626262; }
.freeze-card > p { font-size: 13px; line-height: 1.7; color: #626262; margin: 12px 0 18px; }
.freeze-options { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin: 0; }
.freeze-options > div { padding: 14px; background: #fff; border-radius: 10px; }
.freeze-options dt { font-size: 12px; font-weight: 500; color: #626262; }
.freeze-options dd { font-size: 14px; margin: 6px 0 0; }
.freeze-card .freeze-note { margin: 16px 0 0; font-size: 12px; }
.load-message { padding: 14px; background: #f5f5f5; border-radius: 10px; font-size: 14px; }
@media (max-width: 767px) {
  .training-page { padding-top: 20px; padding-bottom: 28px; }
  .package-hero { padding: 26px; gap: 20px; }
  .package-image { width: 140px; height: 120px; }
  .rights-grid { grid-template-columns: 1fr; gap: 12px; }
  .right-card { padding: 20px; }
  .right-value { margin: 8px 0 14px; }
  .right-value > span:first-child { font-size: 36px; }
  .details-grid { grid-template-columns: 1fr; gap: 16px; }
  .benefits-card, .freeze-card { padding: 24px; }
}
@media (max-width: 479px) {
  .package-hero { flex-direction: column; align-items: flex-start; padding: 24px; }
  .package-image { align-self: center; max-width: 100%; height: 100px; }
  .freeze-options { gap: 8px; }
  .freeze-options > div { padding: 12px; }
}
</style>
